/** A URL this app does not have. Two doors out, and no apology. */

import { EmptyState, SurfaceHeader, TextLink } from '@atlas-nook/design-system';
import type { JSX } from 'react';
import { useNavigate } from 'react-router';

import { ADMIN_STRINGS as S } from '../strings.js';

export function NotFound(): JSX.Element {
  const navigate = useNavigate();
  return (
    <>
      <SurfaceHeader kicker={S.app.descriptor} title="Nothing here" />
      <EmptyState
        title="That address is not part of the admin app."
        actions={
          <>
            <TextLink onClick={() => void navigate('/mediums')}>{S.nav.catalog}</TextLink>
            <TextLink onClick={() => void navigate('/globals')}>{S.nav.globals}</TextLink>
          </>
        }
      />
    </>
  );
}
